import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { Resource } from '@interfaces/Resource';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { EstimateService } from '@shared/services/estimate.service';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'pop-resource-picker',
  templateUrl: './resource-picker.component.html',
  styleUrls: ['./resource-picker.component.less']
})
export class ResourcePickerComponent extends BaseComponent implements OnInit {
  @Input()
  public disabled = false;

  @Input()
  public isManagersOnly = false;

  public hasFocus: boolean;

  public filteredResources?: Resource[];
  private allResources: Resource[];

  private _selectedResourceCode: string | undefined;

  @Input()
  public get selectedResourceCode() {
    return this._selectedResourceCode;
  }
  public set selectedResourceCode(value: string | undefined) {
    this._selectedResourceCode = value;
    this.selectedResourceCodeChange.emit(value);
    this.selectResource();
  }

  @Output()
  public selectedResourceCodeChange = new EventEmitter<string | undefined>();

  private _selectedResource: Resource | undefined;
  @Input()
  public get selectedResource() {
    return this._selectedResource;
  }
  public set selectedResource(value: Resource | undefined) {
    this._selectedResource = value;
    this.selectedResourceChange.emit(value);
    if (this.selectedResourceCode !== value?.code) {
      this.selectedResourceCode = value?.code;
    }
  }

  @Output()
  public selectedResourceChange = new EventEmitter<Resource | undefined>();

  public searchText: string;

  public constructor(
    private estimateService: EstimateService,
    private settingsService: EstimateSettingsService,
    private userService: UserService
  ) {
    super();
  }

  public async ngOnInit() {
    const user = await this.userService.getUserAsync();
    const config = await this.settingsService.getEstimateConfigurationAsync(false);
    const managerClassIds = this.settingsService.getManagerClassificationCodes(config);
    const restrictedCompanies = this.settingsService.getRestrictedCompanies(config);

    this.allResources = await this.estimateService.getResources(user, restrictedCompanies);

    if (this.isManagersOnly) {
      this.allResources = this.allResources.filter(r => managerClassIds.includes(r.classId));
    }
    if (this.selectedResource && !this.allResources.find(r => r.code === this.selectedResourceCode)) {
      this.allResources.push(this.selectedResource);
    }
    this.filteredResources = this.allResources;
  }

  private selectResource() {
    if (this.allResources) {
      this.selectedResource = this.allResources.find(r => r.code === this.selectedResourceCode);
      this.allResources.find(r => r.code === this.selectedResourceCode);
    }
  }

  public resetQueryManagers() {
    this.searchText = '';
  }
  public queryManagers() {
    this.filteredResources = this.allResources.filter(r => r.name?.toLowerCase().includes(this.searchText));
  }
}
